// extracted by mini-css-extract-plugin
export var actionButton = "_jo-0";
export var actionMenuContainer = "_jo-i";
export var bubble = "_jo-2";
export var bubbleActionMenu = "_jo-j";
export var bubbleContext = "_jo-6";
export var bubbleItems = "_jo-7";
export var customer = "_jo-3";
export var divider = "_jo-8";
export var fileList = "_jo-9";
export var hiddenComment = "_jo-o";
export var infoAbove = "_jo-a";
export var internal = "_jo-4";
export var lightActionButton = "_jo-1";
export var link = "_jo-b";
export var merchant = "_jo-5";
export var message = "_jo-c";
export var profilePicture = "_jo-e";
export var quillToolbarContainer = "_jo-f";
export var senderDate = "_jo-g";
export var senderDateCustomer = "_jo-h";
export var senderName = "_jo-d";
export var time = "_jo-k";
export var uploadedImage = "_jo-l";
export var username = "_jo-m";
export var xsmall = "_jo-n";